import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import useFetch from "../hooks/useFetch";
import RelatedProducts from "../components/RelatedProducts";
import { CartContext } from "../context/CartContext";
const ProductDetails = () => {
  const { addToCart } = useContext(CartContext);
  const { id } = useParams();
  const { data, loading } = useFetch(
    `/products?populate=*&filters[id][$eq]=${id}`
  );

  const product = data?.[0];
  const imageUrl = product?.image?.url
    ? `https://cms.sapnafashions.com${product.image.url}`
    : "";
  const placeholder = "https://placehold.co/400x400?text=No+Image";
  //Category title
  // const categoryTitle = data;
  const categoryTitle =
    data?.[0]?.categories?.[0]?.title ?? "No Category Title";

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-28 px-4">
      <div className="max-w-6xl mx-auto">
        {loading ? (
          <div className="flex justify-center items-center h-96">
            <div className="animate-spin rounded-full h-14 w-14 border-4 border-white border-t-transparent"></div>
          </div>
        ) : (
          <div className="bg-gray-800 shadow-2xl rounded-2xl p-6 md:p-12 flex flex-col lg:flex-row gap-10 transition-all duration-300">
            {/* Image */}
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={imageUrl || placeholder}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = placeholder;
                }}
                alt={product?.title || "Product Image"}
                className="rounded-xl w-full max-w-md h-auto object-contain shadow-lg"
              />
            </div>

            {/* Info */}
            <div className="w-full lg:w-1/2 flex flex-col justify-center gap-4">
              <h1 className="text-3xl font-bold">{product?.title}</h1>
              <p className="text-gray-300">{product?.description}</p>
              <div className="text-2xl font-bold text-[#f24a04]">
                ${product?.price || "N/A"}
              </div>
              <button
                onClick={() => addToCart(data, id)}
                className="mt-4 bg-[#f24a04] hover:bg-green-600 text-white py-2 px-6 rounded-lg transition duration-200 w-max"
              >
                Add to Cart
              </button>
            </div>
          </div>
        )}

        {/* Related Products */}
        <div className="mt-20">
          <RelatedProducts categoryTitle={categoryTitle} />
        </div>
      </div>
    </div>
  );
};

export default ProductDetails;
